export const BAG_PATH_SEPARATOR = ' > ';

export const BAGS_CATEGORY_TREE = {
  Men: [
    'Backpacks',
    'Briefcases',
    'Messenger Bags',
    'Crossbody Bags',
    'Laptop Bags',
    'Duffel & Gym Bags',
    'Travel Bags',
    'Tote Bags',
    'Belt Bags & Waist Packs',
    'Sling Bags',
    'Wallets & Card Holders',
    'Luggage',
    'Bag Accessories',
  ],
  Women: [
    'Handbags',
    'Shoulder Bags',
    'Tote Bags',
    'Crossbody Bags',
    'Satchels',
    'Clutches & Evening Bags',
    'Backpacks',
    'Wallets & Card Holders',
    'Cosmetic & Makeup Bags',
    'Travel Bags',
    'Duffel Bags',
    'Belt Bags & Waist Packs',
    'Diaper Bags',
    'Luggage',
    'Bag Accessories',
  ],
  Kids: [
    'School Backpacks',
    'Lunch Bags',
    'Mini Backpacks',
    'Crossbody Bags',
    'Tote Bags',
    'Duffel & Sports Bags',
    'Rolling Backpacks',
    'Travel Bags',
    'Pencil Cases & Pouches',
    'Character Bags',
    'Diaper Bags (Baby)',
    'Bag Accessories',
  ],
};

export const BAG_DEPARTMENTS = Object.keys(BAGS_CATEGORY_TREE);

export function isBagsListingCategory(category) {
  return category === 'Bags';
}

export function joinBagSubcategoryPath(parts) {
  return parts.filter(Boolean).join(BAG_PATH_SEPARATOR);
}

export function parseBagSubcategoryPath(value) {
  if (!value) {
    return { department: '', subcategory: '' };
  }
  const [department = '', subcategory = ''] = String(value).split(BAG_PATH_SEPARATOR);
  return { department, subcategory };
}

export function getBagSubcategories(department) {
  return BAGS_CATEGORY_TREE[department] || [];
}

export function getBagDepartmentsForBrowse() {
  return BAG_DEPARTMENTS;
}
